import { lazy } from "react";

const UbicacionesLayout = lazy(() =>
      import("../../ubicaciones/UbicacionesLayout.jsx")
);

const ubicacionesRoutes = [
      {
            path: "ubicaciones",
            element: <UbicacionesLayout />,
      },
];

export default ubicacionesRoutes;
